import { useMediaQuery } from '@vueuse/core';

/**
 * Реактивный флаг touch-устройства: `true`, когда основной способ ввода —
 * неточный указатель без hover (телефон/планшет, включая iPad с клавиатурой).
 * Не путать с `useIsMobile` (layout-граница по ширине viewport < 1280):
 * суженное desktop-окно здесь остаётся `false`, широкий iPad — `true`.
 */
export function useIsTouchDevice() {
  const isTouchDevice = useMediaQuery('(hover: none) and (pointer: coarse)');

  return { isTouchDevice };
}
